// Razorpay Checkout (https://razorpay.com/docs/payments/payment-gateway/web-integration/standard/): the store
// owner's Razorpay account takes the payment in a popup on this page. UPI comes first (the UPI apps on a phone and a QR
// code on a computer), then cards, net banking and wallets. Shoppers outside India see cards, net banking and wallets
// first, since UPI needs an Indian bank account; international cards work once the Razorpay account has them turned
// on. Payments are always in rupees, so PayPal (foreign currencies only) does not show. `checkout` comes from
// the server: a shopper's order (POST /storefront/orders, /orders/:id/pay) or a website purchase on Ownezzy's account
// (POST /onboarding/stores, /billing/payments/:id/checkout).
import { isInternational } from "../shared/signup/usd";

const SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";
let loading = null;

const loadScript = () => {
    if (window.Razorpay) return Promise.resolve();
    if (!loading) {
        loading = new Promise((resolve, reject) => {
            const tag = document.createElement("script");
            tag.src = SCRIPT;
            tag.async = true;
            tag.onload = resolve;
            tag.onerror = () => {
                loading = null;
                reject(new Error("The payment window could not be loaded. Check your connection and try again."));
            };
            document.body.appendChild(tag);
        });
    }
    return loading;
};

// onPaid({ paymentId, signature }) after a successful payment; onClose() when the shopper closes the popup unpaid
export async function openRazorpay(checkout, { shopper = {}, color, onPaid, onClose }) {
    await loadScript();
    const abroad = isInternational();
    const rzp = new window.Razorpay({
        key: checkout.keyId,
        order_id: checkout.providerOrderId,
        amount: checkout.amountPaise,
        currency: "INR",
        name: checkout.name,
        description: checkout.description,
        prefill: { name: shopper.name || "", contact: shopper.phone || "", email: shopper.email || "" },
        theme: color ? { color } : undefined,
        config: {
            display: {
                blocks: { first: abroad ? { name: "Card, net banking or wallet", instruments: [{ method: "card" }, { method: "netbanking" }, { method: "wallet" }] } : { name: "Pay by UPI", instruments: [{ method: "upi" }] } },
                sequence: ["block.first"],
                preferences: { show_default_blocks: true }, // then every other method on the account
            },
        },
        handler: (res) => onPaid({ paymentId: res.razorpay_payment_id, signature: res.razorpay_signature }),
        modal: { ondismiss: onClose, confirm_close: true },
    });
    rzp.open();
}
